module.exports = __webpack_public_path__ + "img/logo-1.50ae69d0.png";